module.exports = __webpack_public_path__ + "static/media/scenario2.b7b6ce40.png";